import { render, staticRenderFns } from "./ImportNewForm.vue?vue&type=template&id=3d0b2c78&"
import script from "./ImportNewForm.vue?vue&type=script&lang=js&"
export * from "./ImportNewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports